import(/* webpackMode: "eager", webpackExports: ["BlogDetail"] */ "/app/components/blog/detail/BlogDetail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
